module.exports = __webpack_public_path__ + "static/media/passport-example.31ba11db.gif";